import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getReferralByCode, createReferral } from '../services/dataService';
import '../styles/Referral.css';

// ============================================
// PAGE : Consulter / Utiliser un code parrainage
// ============================================
export function ReferralPage() {
  const { referralCode } = useParams();
  const [referral, setReferral] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getReferralByCode(referralCode);
        if (data) {
          setReferral(data);
        } else {
          setError("Code de parrainage introuvable.");
        }
      } catch (err) {
        setError("Impossible de charger le parrainage.");
      } finally {
        setLoading(false);
      }
    };
    if (referralCode) load();
    else setLoading(false);
  }, [referralCode]);

  if (loading) return <div className="referral-container"><p className="ref-loading">Chargement...</p></div>;

  if (error) {
    return (
      <div className="referral-container">
        <div className="ref-error">
          <p>{error}</p>
          <a href="https://laserbay.net/reservation.html" className="ref-book-btn">Réserver quand même 🎯</a>
        </div>
      </div>
    );
  }

  return (
    <div className="referral-container">
      <div className="ref-card">
        <div className="ref-badge">🤝 PARRAINAGE</div>
        
        <h2>Vous avez été parrainé(e) !</h2>
        
        <p className="ref-intro">
          <strong>{referral.sponsorName}</strong> vous recommande LaserBay — 
          le Laser Tag en plein air à Agon-Coutainville !
        </p>

        <div className="ref-offer">
          <div className="ref-offer-icon">🎁</div>
          <div className="ref-offer-detail">
            <span className="ref-offer-title">-10% sur votre première session</span>
            <span className="ref-offer-desc">
              Mentionnez le code <strong>{referral.code}</strong> lors de votre réservation
            </span>
          </div>
        </div>

        <a href="https://laserbay.net/reservation.html" className="ref-book-btn">
          Réserver avec -10% 🎯
        </a>

        <div className="ref-info">
          <p>📍 53 la Charrière du Commerce, Agon-Coutainville</p>
          <p>📞 02 44 84 99 96</p>
          <p>🌐 laserbay.net</p>
        </div>
      </div>
    </div>
  );
}

export default ReferralPage;
